import React from 'react';
import { Clock, CheckCircle, AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { formatDate } from './helpers';

export const ComplianceClockCard = ({ report, ackDays, feedbackDays, updating, onSendAcknowledgment }) => (
  <Card className={ackDays !== null && ackDays < 0 && !report.acknowledgment_sent_at ? 'border-red-200' : ''}>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Clock className="w-5 h-5" />
        Compliance Clock
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className={`p-3 rounded-lg ${report.acknowledgment_sent_at ? 'bg-emerald-50' : ackDays < 0 ? 'bg-red-50' : 'bg-amber-50'}`}>
        <div className="flex items-center justify-between mb-1">
          <span className="text-sm font-medium">Confirmação de Receção (D+7)</span>
          {report.acknowledgment_sent_at ? (
            <CheckCircle className="w-4 h-4 text-emerald-600" />
          ) : ackDays < 0 ? (
            <AlertTriangle className="w-4 h-4 text-red-600" />
          ) : (
            <Clock className="w-4 h-4 text-amber-600" />
          )}
        </div>
        {report.acknowledgment_sent_at ? (
          <p className="text-xs text-emerald-700">Enviado em {formatDate(report.acknowledgment_sent_at)}</p>
        ) : (
          <>
            <p className={`text-xs ${ackDays < 0 ? 'text-red-700' : 'text-amber-700'}`}>
              {ackDays < 0 ? `Vencido há ${Math.abs(ackDays)} dias` : `${ackDays} dias restantes`}
            </p>
            <Button
              size="sm"
              className="mt-2 w-full"
              onClick={onSendAcknowledgment}
              disabled={updating}
              data-testid="send-ack-btn"
            >
              Registar Confirmação Enviada
            </Button>
          </>
        )}
      </div>

      <div className={`p-3 rounded-lg ${['CONCLUIDA', 'ARQUIVADA'].includes(report.status) ? 'bg-emerald-50' : feedbackDays < 0 ? 'bg-red-50' : feedbackDays < 15 ? 'bg-amber-50' : 'bg-slate-50'}`}>
        <div className="flex items-center justify-between mb-1">
          <span className="text-sm font-medium">Feedback (D+90)</span>
          {['CONCLUIDA', 'ARQUIVADA'].includes(report.status) ? (
            <CheckCircle className="w-4 h-4 text-emerald-600" />
          ) : feedbackDays < 0 ? (
            <AlertTriangle className="w-4 h-4 text-red-600" />
          ) : (
            <Clock className="w-4 h-4 text-amber-600" />
          )}
        </div>
        <p className={`text-xs ${feedbackDays < 0 ? 'text-red-700' : feedbackDays < 15 ? 'text-amber-700' : 'text-slate-600'}`}>
          {['CONCLUIDA', 'ARQUIVADA'].includes(report.status)
            ? 'Concluído'
            : feedbackDays < 0
              ? `Vencido há ${Math.abs(feedbackDays)} dias`
              : `${feedbackDays} dias restantes`}
        </p>
      </div>
    </CardContent>
  </Card>
);
